import React from 'react';
import { CommonLabeledSelectProps } from '../../../types/common';
import ErrorLabel from '../ErrorLabel';
import InnerLabel from '../InnerLabel';
import Dropdown from '../Dropdown';

export const LabeledDropdownTestId = 'labeleddropdown-input';
export type LabeledDropdownProps = CommonLabeledSelectProps;

const LabeledDropdown: React.FC<LabeledDropdownProps> = ({
  name,
  options,
  label,
  errorLabel,
  className = '',
  inputClassName,
  labelClassName,
  autoComplete,
  defaultValue,
  disabled,
  readOnly,
  register,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
}: LabeledDropdownProps) => {
  const readOnlyInputStyle = readOnly ? 'text-gray-400' : '';
  const inputClasses = `${inputClassName || ''} pt-5 w-full pl-4 pb-1
    ${readOnlyInputStyle} border-1-half rounded border-transparent checkout-panel-form-input
    focus:border-[color:var(--form-accent-color)] outline-none pl-3
    bg-gray-50 cursor-pointer appearance-none  pointer-events-none`;
  const labelClasses = `absolute ${
    labelClassName || ''
  } checkout-panel-form-label`;

  return (
    <div
      className={`m-2 ${className} relative`}
      data-testid={LabeledDropdownTestId}
    >
      <InnerLabel
        inputName={name}
        hasErrors={!!errorLabel}
        className={labelClasses}
        showAsPlaceholder={false}
      >
        {label}
      </InnerLabel>
      <Dropdown
        name={name}
        displayText={label}
        options={options}
        hasErrors={!!errorLabel}
        className={inputClasses}
        register={register}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <ErrorLabel>{errorLabel}</ErrorLabel>
    </div>
  );
};

export default LabeledDropdown;
